// Module
var code = "<div class=\"close\" ng-click=\"vm.confirm()\">Close</div><h2 class=\"no-underline\">Welcome</h2><p ng-bind=\"vm.message\"></p>";
// Exports
module.exports = code;